module.exports = __webpack_public_path__ + "media/newstyle/images/new-icon-linkedin-ea2b3ea5a6b4012c9256bbbd2d8794b0.svg";